module.exports = __webpack_public_path__ + "img/manage.bf0aad72.svg";